import axios from 'axios';
import { Promise } from "es6-promise";
import * as auth from './auth';
import { store } from './store';
import * as authService from './msal'

export default () => {

  axios.interceptors.response.use(async (response) => {
    // Return a successful response back to the calling service
    return response;
  }, async (error) => {
    // Return any error which is not due to authentication back to the calling service
    store.dispatch('log', `${error.config.method.toUpperCase()}: ${error.config.url} failed`);
    let authProvider = store.getters.getAuthProvider;
    if (!error.response || error.response.status !== 401) {
      if (!error.response) {
        store.dispatch('log', 'No response');
      }
      else {
        store.dispatch('log', `Response: ${error.response.status}. ${error.response.statusText}.`);
        if (error.response.data) {
          store.dispatch('log', `Response Body: ${JSON.stringify(error.response.data)}`);
        }
      }
      // return new Promise((resolve, reject) => {
      //   reject(error);
      // });
      return Promise.reject(error);
    }
    store.dispatch('log', `Response: ${error.response.status}. ${error.response.statusText}.`);
    if (error.response.data) {
      store.dispatch('log', `Response Body: ${JSON.stringify(error.response.data)}`);
    }

    store.dispatch('log', `Auth Provider: ${authProvider}`);
    if (authProvider === "Microsoft") {
      store.dispatch('log', `Attempting to get new token using Microsoft Auth`);
      return await authService.getToken()
        .then(async (response) => {
          if (response && response.idToken) {
            let token = response.idToken;
            store.dispatch('setToken', token);
            store.dispatch('setTokenExpiration', response.expiresOn);

            const config = error.config;
            config.headers['Authorization'] = `Bearer ${token}`;
            store.dispatch('log', `Resending request with new token.`);
            
            return axios.request(config);
          } else {
            store.dispatch('log', `MS token response is not valid.`);
            store.dispatch('setReturnUrl', window.location.pathname);
            store.dispatch('setAuthError', "Sorry, but your authentication expired. Please make sure third-party cookies are enabled.");
            await auth.clearSession();
            return Promise.reject(error);
          }
        })
        .catch(err => {
          store.dispatch('log', `Error attempting to retrieve MS token.`)
          store.dispatch('log', `Error: ${JSON.stringify(err)}`);
          return Promise.reject(err);
        });
    } else if (authProvider === "DashTech") {
      store.dispatch('log', `Attempting to get new token using DashTech Auth`);
      // Try request again with new token
      return auth.getNewToken()
        .then((response) => {
          let token = response.data.accessToken;
          store.dispatch('setToken', token);
          store.dispatch('setTokenExpiration', new Date(response.data.expirationTime));
          localStorage.setItem('refreshToken', response.data.refreshToken);
          
          // New request with new token
          const config = error.config;
          config.headers['Authorization'] = `Bearer ${token}`;
          store.dispatch('log', `Resending request with new token.`);
          return new Promise((resolve, reject) => {
            axios.request(config)
            .then(response => {
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            })
          });
        })
        .catch(err => {
          store.dispatch('log', `Error attempting to retrieve DashTech token.`)
          store.dispatch('log', `Error: ${JSON.stringify(err)}`);
          return Promise.reject(err);
        });
    } else {
      store.dispatch('log', `No Auth Provider, so return the error`);
      //Promise.reject(error);
      return Promise.reject(error);
    }
  });
}